module.exports = __webpack_public_path__ + "img/frame (262).373d511c.jpg";